import first from 'lodash/first';
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import qs from 'qs';

export const extractFirstValue = (raw: string | string[]) => {
  if (Array.isArray(raw)) {
    return first(raw);
  }

  return raw;
};

export const convertToArray = (raw: string | string[]) => {
  if (!raw) {
    return [];
  }

  if (Array.isArray(raw)) {
    return raw;
  }

  return [raw];
};

export const convertItemIdsToArray = (raw: string | string[]) => {
  if (!raw) {
    return [];
  }
  const firstValue = extractFirstValue(raw);

  const transformItemIds = (itemIdsString: string) => {
    const decodedURI = decodeURIComponent(itemIdsString);
    return decodedURI.split(',');
  };

  return transformItemIds(firstValue);
};

export function formatQuery(queryParameters: object): string {
  return qs.stringify(queryParameters, { skipNulls: true });
}

type QueryParamObject = { [key: string]: string | number };

export function removeNullValuesInQuery(
  queryParameters: object,
): QueryParamObject {
  return omitBy(queryParameters, isNil);
}
